import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class PlayBlocksGettingStartedIcon extends BaseIcon {
    getChildren = () => {
        const color = this.getColor() === 'currentColor' ? '#7985a3' : this.getColor()
        return [
            <g transform="translate(0.771 0.946)">
                <path d="M6.541,16.416l9.048-3.373a1.693,1.693,0,0,0,.65-2.777L10.564,4.591a1.707,1.707,0,0,0-2.79.718L4.414,14.357a1.653,1.653,0,0,0,2.127,2.059Z" transform="translate(-4.336 0.489)" fill="none" stroke={color} strokeLinecap="round" stroke-linejoin="round" strokeWidth="1.5"/>
                <path d="M4.028,7.223A2.79,2.79,0,0,0,2.05,6.938" transform="translate(11.451 1.46)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
                <path d="M3.98,4.794A2.845,2.845,0,0,0,4.427,2.83" transform="translate(8.41 0.028)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
                <path d="M6.573.72A6.394,6.394,0,0,1,6.4,5.163" transform="translate(2.702 -0.72)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
                <ellipse cx="0.677" cy="0.677" rx="0.677" ry="0.677" transform="translate(16.224 2.79)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
            </g>
        ]
    }
    getViewBox = () => '0 0 19.099 18.719'
}
